import React from 'react';
import { Form } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import './file64.css';

const File64 = (props) => {
  const { setFile, label, id, ...restOfProps } = props;
  const onDrop = (acceptedFiles) => {
    let file = acceptedFiles[0];
    setFile(file);
    // const reader = new FileReader();
    // reader.onload = event => {
    //   props.setFile(event.target.result);
    // };
    // reader.readAsDataURL(file);
  };

  return (
    <div className="margin-top-2em">
      <Form.Group controlId="formBasicFile">
        <Form.Label>{label}</Form.Label>
        <Dropzone onDrop={onDrop}>
          {({ getRootProps, getInputProps }) => (
            <div className="form-group input-container" {...getRootProps()}>
              <input
                style={{ display: 'inline!important' }}
                className="form-control"
                {...getInputProps()}
                id={id}
                name={id}
                {...restOfProps}
              />
            </div>
          )}
        </Dropzone>
      </Form.Group>
    </div>
  );
};
export default File64;
